<script>
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

export default {
  setup() {
    // I18n
    const { t } = useI18n();

    // Variables
    const isLoading = ref(true);

    onMounted(async () => {

    });

    return {
      t,
      isLoading,
    }
  },
};
</script>

<template>
    <div class="vh-screen flex flex-col">
        <p>Manage payments settings page</p>
    </div>
</template>


<style lang="scss" scoped>
@import '@/assets/styles/views/settings/personal_information';
</style>
